import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  calculateDateProgress,
  formatDate,
  validateSubscription
} from '../../../common/formatDateText';

export const SliderDayPayment = () => {
  const { user } = useSelector((state) => state.user);
  const { paymentDeadlineDate, lastDatePayment, _id: userId } = user;

  const statusSubscription = validateSubscription(paymentDeadlineDate);
  
  return (
    <div className='w-full flex flex-col items-center justify-center p-2 gap-4'>

      {
        statusSubscription && (
          <div className='w-full flex flex-col items-center justify-center p-2 gap-4'>
            <h1 className='text-[1.4rem] text-gray-800 font-semibold'>Tu suscripción está activa</h1>
            <p className='text-md text-center text-gray-600'>Próxima fecha de pago</p>
            <p className='text-md font-semibold text-center text-gray-600'>{formatDate(paymentDeadlineDate)}</p>
            <div className='w-[100%]'>
              <div className="w-full bg-gray-200 rounded-full h-4">
                <div
                  className={`h-4 rounded-full bg-rose-500 transition-all duration-300 ease-in-out`}
                  style={{ width: `${Math.min(calculateDateProgress(new Date(lastDatePayment), new Date(paymentDeadlineDate)), 100)}%` }}
                ></div>
              </div>
            </div>
            <Link
              to={`/mis-pagos/${userId}`}
              className="flex justify-center text-sm font-semibold shadow-sm bg-indigo-600 px-4 py-2 text-white rounded hover:bg-indigo-800"
            >
              Historial de pagos
            </Link>
          </div>
        )
      }
      {
        !statusSubscription && (
          <div className='w-full flex flex-col items-center justify-center p-2 gap-4'>
            <h1 className='text-[1.4rem] text-gray-800 font-semibold'>Tu suscripción está vencida</h1>
            <p className='text-sm text-center text-gray-600'>Por favor, renueva tu suscripción para continuar disfrutando de nuestros servicios.</p>
            <Link
              to={`/mis-pagos/${userId}`}
              className="flex justify-center text-sm font-semibold shadow-sm bg-indigo-600 px-4 py-2 text-white rounded hover:bg-indigo-800"
            >
              Renovar Suscripción
            </Link>
          </div>
        )
      }
    </div>
  )
}
